import React, { PureComponent } from "react";

import Carousel from "react-bootstrap/Carousel";
import "./editor-materials.css";
import HyperModal from "react-hyper-modal";
import { withTranslation } from "react-i18next";

class EditorMaterials extends PureComponent {
  constructor(props) {
    super(props);
    const { t } = props;

    this.materials = [
      {
        id: "Бумага",
        name: t("Папір"),
        info: {
          name: t("Друк на папері"),
          description: t(
            "Ми використовуємо високоякісний кольоровий друк на матовому папері високої щільності. Такий друк забезпечує фотореалістичність і високу деталізацію плакатів. Плакати 30*40 пересилаємо в захисній папці, 40*50см і 50*70см - у трикутному тубусі."
          ),
          images: [
            process.env.PUBLIC_URL + "/assets/img/paper1.jpg",
            process.env.PUBLIC_URL + "/assets/img/paper2.jpg",
            process.env.PUBLIC_URL + "/assets/img/paper3.jpg",
          ],
        },
        sizes: [
          {
            id: "21х30 см",
            name: "21х30 см",
            width: 210,
            height: 300,
            ratio: "7-10",
            price: 320,
            oldPrice: 390,
            hangers: [
              { id: "Нет", name: t("Немає"), price: 0 },
              {
                id: "Рамка",
                name: t("Рамка"),
                price: 230,
                info: {
                  name: t("Рамка для плакату"),
                  description: t(
                    "Ми використовуємо якісні тонкі пластикові рамки чорного кольору зі склом (натуральним або акриловим) та зручним підвісом. Такі рамки добре підходять до будь-якого стилю інтер’єру. Задня стінка - ДВП з гачками"
                  ),
                  images: [
                    process.env.PUBLIC_URL + "/assets/img/frame1.png",
                    process.env.PUBLIC_URL + "/assets/img/frame2.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame3.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame4.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame5.jpg",
                  ],
                },
              },
            ],
          },
          {
            id: "30х40 см",
            name: "30х40 см",
            width: 300,
            height: 400,
            ratio: "3-4",
            price: 390,
            oldPrice: 440,
            hangers: [
              { id: "Нет", name: t("Немає"), price: 0 },
              {
                id: "Рамка",
                name: t("Рамка"),
                price: 260,
                info: {
                  name: t("Рамка для плакату"),
                  description: t(
                    "Ми використовуємо якісні тонкі пластикові рамки чорного кольору зі склом (натуральним або акриловим) та зручним підвісом. Такі рамки добре підходять до будь-якого стилю інтер’єру. Задня стінка - ДВП з гачками"
                  ),
                  images: [
                    process.env.PUBLIC_URL + "/assets/img/frame1.png",
                    process.env.PUBLIC_URL + "/assets/img/frame2.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame3.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame4.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame5.jpg",
                  ],
                },
              },
            ],
          },
          {
            id: "40х50 см",
            name: "40х50 см",
            width: 400,
            height: 500,
            ratio: "4-5",
            price: 490,
            oldPrice: 640,
            hangers: [
              { id: "Нет", name: t("Немає"), price: 0 },
              {
                id: "Рамка",
                name: t("Рамка"),
                price: 360,
                info: {
                  name: t("Рамка для плакату"),
                  description: t(
                    "Ми використовуємо якісні тонкі пластикові рамки чорного кольору зі склом (натуральним або акриловим) та зручним підвісом. Такі рамки добре підходять до будь-якого стилю інтер’єру. Задня стінка - ДВП з гачками"
                  ),
                  images: [
                    process.env.PUBLIC_URL + "/assets/img/frame1.png",
                    process.env.PUBLIC_URL + "/assets/img/frame2.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame3.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame4.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame5.jpg",
                  ],
                },
              },
            ],
          },
          {
            id: "50х70 см",
            name: "50х70 см",
            width: 500,
            height: 700,
            ratio: "5-7",
            price: 590,
            oldPrice: 720,
            hangers: [
              { id: "Нет", name: t("Немає"), price: 0 },
              {
                id: "Рамка",
                name: t("Рамка"),
                price: 560,
                info: {
                  name: t("Рамка для плакату"),
                  description: t(
                    "Ми використовуємо якісні тонкі пластикові рамки чорного кольору зі склом (натуральним або акриловим) та зручним підвісом. Такі рамки добре підходять до будь-якого стилю інтер’єру. Задня стінка - ДВП з гачками"
                  ),
                  images: [
                    process.env.PUBLIC_URL + "/assets/img/frame1.png",
                    process.env.PUBLIC_URL + "/assets/img/frame2.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame3.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame4.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame5.jpg",
                  ],
                },
              },
            ],
          },
        ],
      },
      {
        id: "ПВХ",
        name: t("Пластик"),
        info: {
          name: t("Друк на ПВХ"),
          description: t(
            "ПВХ - легковісний лист пластику зі вспіненою структурою. Його можна підвішувати без рами, оскільки він достатньо щільний і не скручується. Безкоштовно можемо наклеїти двосторонній скотч, щоб кріпити до стіни. Товщина - 3мм, або 1мм (якщо в комплекті з рамкою).\nБезпечний для людини та навколишнього середовища"
          ),
          images: [
            process.env.PUBLIC_URL + "/assets/img/plastic1.jpg",
            process.env.PUBLIC_URL + "/assets/img/plastic2.jpg",
            process.env.PUBLIC_URL + "/assets/img/plastic3.jpg",
          ],
        },
        sizes: [
          {
            id: "30х40 см",
            name: "30х40 см",
            width: 300,
            height: 400,
            ratio: "3-4",
            price: 550,
            oldPrice: 690,
            hangers: [
              { id: "Нет", name: t("Немає"), price: 0 },
              {
                id: "Лента",
                name: t("Клейка стрічка"),
                price: 0,
                isDefault: true,
                info: {
                  name: t("Клейка стрічка"),
                  description: t(
                    "Чіпкий скотч по периметру зворотної сторони. Добре тримає вагу, якщо поверхня не має надто виразної фактури."
                  ),
                  images: [process.env.PUBLIC_URL + "/assets/img/plastic3.jpg"],
                },
              },
              {
                id: "Рамка",
                name: t("Рамка"),
                price: 200,
                info: {
                  name: t("Рамка для плакату"),
                  description: t(
                    "Ми використовуємо якісні тонкі пластикові рамки чорного кольору зі склом (натуральним або акриловим) та зручним підвісом. Такі рамки добре підходять до будь-якого стилю інтер’єру. Задня стінка - ДВП з гачками"
                  ),
                  images: [
                    process.env.PUBLIC_URL + "/assets/img/frame1.png",
                    process.env.PUBLIC_URL + "/assets/img/frame2.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame3.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame4.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame5.jpg",
                  ],
                },
              },
              /*{
              id: "Крючки",
              name: "Гачки",
              price: 30,
              info: {
                name: "Гачки",
                description:
                  "Гачки на зворотній стороні. На випадок, якщо маєте дуже фактурну поверхню і двостороннього скотча недостатньо.",
                images: ["assets/img/plastic_hooks.jpg"],
              },
            },*/
            ],
          },
          {
            id: "40х50 см",
            name: "40х50 см",
            width: 400,
            height: 500,
            ratio: "4-5",
            price: 700,
            oldPrice: 880,
            hangers: [
              { id: "Нет", name: t("Немає"), price: 0 },
              {
                id: "Лента",
                name: t("Клейка стрічка"),
                price: 0,
                isDefault: true,
                info: {
                  name: t("Клейка стрічка"),
                  description: t(
                    "Чіпкий скотч по периметру зворотної сторони. Добре тримає вагу, якщо поверхня не має надто виразної фактури."
                  ),
                  images: [process.env.PUBLIC_URL + "/assets/img/plastic3.jpg"],
                },
              },
              {
                id: "Рамка",
                name: t("Рамка"),
                price: 300,
                info: {
                  name: t("Рамка для плакату"),
                  description: t(
                    "Ми використовуємо якісні тонкі пластикові рамки чорного кольору зі склом (натуральним або акриловим) та зручним підвісом. Такі рамки добре підходять до будь-якого стилю інтер’єру. Задня стінка - ДВП з гачками"
                  ),
                  images: [
                    process.env.PUBLIC_URL + "/assets/img/frame1.png",
                    process.env.PUBLIC_URL + "/assets/img/frame2.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame3.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame4.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame5.jpg",
                  ],
                },
              },
              // {
              //   id: "Крючки",
              //   name: "Гачки",
              //   price: 30,
              //   info: {
              //     name: "Гачки",
              //     description:
              //       "Гачки на зворотній стороні. На випадок, якщо маєте дуже фактурну поверхню і двостороннього скотча недостатньо.",
              //     images: ["assets/img/plastic_hooks.jpg"],
              //   },
              // },
            ],
          },
          {
            id: "50х70 см",
            name: "50х70 см",
            width: 500,
            height: 700,
            ratio: "5-7",
            price: 950,
            oldPrice: 1200,
            hangers: [
              { id: "Нет", name: "Немає", price: 0 },
              {
                id: t("Лента"),
                name: t("Клейка стрічка"),
                price: 0,
                isDefault: true,
                info: {
                  name: t("Клейка стрічка"),
                  description: t(
                    "Чіпкий скотч по периметру зворотної сторони. Добре тримає вагу, якщо поверхня не має надто виразної фактури."
                  ),
                  images: [process.env.PUBLIC_URL + "/assets/img/plastic3.jpg"],
                },
              },
              {
                id: "Рамка",
                name: t("Рамка"),
                price: 400,
                info: {
                  name: t("Рамка для плакату"),
                  description: t(
                    "Ми використовуємо якісні тонкі пластикові рамки чорного кольору зі склом (натуральним або акриловим) та зручним підвісом. Такі рамки добре підходять до будь-якого стилю інтер’єру. Задня стінка - ДВП з гачками"
                  ),
                  images: [
                    process.env.PUBLIC_URL + "/assets/img/frame1.png",
                    process.env.PUBLIC_URL + "/assets/img/frame2.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame3.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame4.jpg",
                    process.env.PUBLIC_URL + "/assets/img/frame5.jpg",
                  ],
                },
              },
              // {
              //   id: "Крючки",
              //   name: "Гачки",
              //   price: 30,
              //   info: {
              //     name: "Гачки",
              //     description:
              //       "Гачки на зворотній стороні. На випадок, якщо маєте дуже фактурну поверхню і двостороннього скотча недостатньо.",
              //     images: ["assets/img/plastic_hooks.jpg"],
              //   },
              // },
            ],
          },
        ],
      },
      {
        id: "Холст",
        name: t("Холст"),
        info: {
          name: t("Друк на холсті"),
          description: t(
            "Ми друкуємо на натуральному холсті і використовуємо галерейну натяжку на дерев’яний підрамник. При такій натяжці зображення заходить на бокові сторони холсту і загинається під підрамник. Таким чином холст чудово виглядає на стіні і не потребує додаткової рами."
          ),
          images: [
            process.env.PUBLIC_URL + "/assets/img/canvas1.jpg",
            process.env.PUBLIC_URL + "/assets/img/canvas2.jpg",
            process.env.PUBLIC_URL + "/assets/img/canvas3.jpg",
          ],
        },
        sizes: [
          {
            id: "30х40 см",
            name: "30х40 см",
            width: 300,
            height: 400,
            ratio: "3-4",
            price: 890,
            oldPrice: 1130,
            hangers: [{ id: "Крючки", name: t("Гачки"), price: 0 }],
          },
          {
            id: "40х50 см",
            name: "40х50 см",
            width: 400,
            height: 500,
            ratio: "4-5",
            price: 1090,
            oldPrice: 1400,
            hangers: [{ id: "Крючки", name: t("Гачки"), price: 0 }],
          },
          {
            id: "50х70 см",
            name: "50х70 см",
            width: 500,
            height: 700,
            ratio: "5-7",
            price: 1290,
            oldPrice: 1700,
            hangers: [{ id: "Крючки", name: t("Гачки"), price: 0 }],
          },
        ],
      },
    ];

    this.state = {
      selectedMaterialId: props.initialSelectedMaterialId,
      selectedSizeId: props.initialSelectedSizeId,
      selectedHangerId: props.initialSelectedHangerId,
      isModalOpen: false,
      modalName: "",
      modalDescription: "",
      modalImages: [],
    };
  }

  riseUpdate = () => {
    console.log("recalculate price");

    try {
      var material = this.materials.find((material) => {
        return material.id === this.state.selectedMaterialId;
      });

      var size = material.sizes.find((size) => {
        return size.id === this.state.selectedSizeId;
      });

      let { price, ratio, width, height } = size;

      var hanger = size.hangers.find((h) => {
        return h.id === this.state.selectedHangerId;
      });

      price += hanger.price;

      var proposalHangerId = "Рамка";
      var proposalHangerName = "";
      var proposalHangerPrice = 0;
      if (
        this.state.selectedMaterialId === "Бумага" &&
        this.state.selectedHangerId == "Нет"
      ) {
        var frameHanger = size.hangers.find((h) => {
          return h.id === proposalHangerId;
        });
        if (frameHanger) {
          proposalHangerName = frameHanger.name;
          proposalHangerPrice = frameHanger.price;
        }
      }

      this.props.onChanged({
        selectedMaterialId: this.state.selectedMaterialId,
        selectedSizeId: this.state.selectedSizeId,
        selectedHangerId: this.state.selectedHangerId,
        selectedMaterialName: material.name,
        selectedHangerName: hanger.name,
        price,
        ratio,
        width,
        height,
        proposalHangerId,
        proposalHangerName,
        proposalHangerPrice,
      });
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.selectedMaterialId !== prevState.selectedMaterialId ||
      this.state.selectedSizeId !== prevState.selectedSizeId ||
      this.state.selectedHangerId !== prevState.selectedHangerId
    ) {
      this.riseUpdate();
    }
  }

  componentDidMount() {
    this.riseUpdate();
  }

  // useEffect(() => {
  //   riseUpdate();
  // }, [selectedMaterialId, selectedSizeId, selectedHangerId]);

  onMaterialChanged = (changeEvent) => {
    var materialId = changeEvent.target.value;
    var material = this.materials.find((s) => s.id === materialId);
    if (material) {
      var size = material.sizes.find((s) => s.id === this.state.selectedSizeId);
      if (!size) {
        size = material.sizes[1];
      }
      var sizeId = size.id;

      var hangerId = "",
        hanger = null;
      if (
        this.state.selectedHangerId !== "Нет" &&
        this.state.selectedMaterialId !== "ПВХ"
      ) {
        hanger = size.hangers.find((s) => s.id === this.state.selectedHangerId);
      }
      if (!hanger) {
        hanger = size.hangers.find((s) => s.isDefault);
        if (!hanger && size.hangers.length > 0) {
          hanger = size.hangers[0];
        }
      }

      hangerId = hanger.id;

      this.setState({
        selectedMaterialId: materialId,
        selectedSizeId: sizeId,
        selectedHangerId: hangerId,
      });
    }
  };

  onSizeChanged = (changeEvent) => {
    var material = this.materials.find(
      (s) => s.id === this.state.selectedMaterialId
    );
    if (material) {
      var sizeId = changeEvent.target.value;
      var size = material.sizes.find((s) => s.id === sizeId);

      if (size) {
        var hangerId = "",
          hanger = null;
        if (
          this.state.selectedHangerId !== "Нет" &&
          this.state.selectedMaterialId !== "ПВХ"
        ) {
          hanger = size.hangers.find(
            (s) => s.id === this.state.selectedHangerId
          );
        }

        if (!hanger) {
          var hanger = size.hangers.find((s) => s.isDefault);
          if (!hanger && size.hangers.length > 0) {
            hanger = size.hangers[0];
          }
        }

        hangerId = hanger.id;

        this.setState({
          selectedSizeId: sizeId,
          selectedHangerId: hangerId,
        });
      }
    }
  };

  onHangerChanged = (changeEvent) => {
    var material = this.materials.find(
      (s) => s.id === this.state.selectedMaterialId
    );
    if (material) {
      var size = material.sizes.find((s) => s.id === this.state.selectedSizeId);
      if (size) {
        var hangerId = changeEvent.target.value;
        var hanger = size.hangers.find((s) => s.id === hangerId);
        if (!hanger) {
          hanger = size.hangers.find((s) => s.isDefault);
        }
        hangerId = hanger.id;

        this.setState({
          selectedHangerId: hangerId,
        });
      }
    }
  };

  onMaterialInfoClick = (e, material) => {
    e.preventDefault();

    if (material) {
      this.setState({
        modalName: material.info.name,
        modalDescription: material.info.description,
        modalImages: material.info.images,
        isModalOpen: true,
      });
    }
  };

  onHangerInfoClick = (e, hanger) => {
    e.preventDefault();

    if (hanger) {
      this.setState({
        modalName: hanger.info.name,
        modalDescription: hanger.info.description,
        modalImages: hanger.info.images,
        isModalOpen: true,
      });
    }
  };

  onModalClose = (e) => {
    this.setState({
      isModalOpen: false,
    });
  };

  renderModalWindow = (props) => {
    return (
      <HyperModal
        isOpen={props.isModalOpen}
        requestClose={props.onModalClose}
        classes={{
          contentClassName: "custom-modal-content",
          closeIconClassName: "custom-modal-icon",
          wrapperClassName: "custom-modal-wrapper",
        }}
      >
        <div class="modal-header">
          <h5 class="modal-title">{props.name}</h5>
        </div>
        <div class="modal-body modal-material">
          <p style={{ whiteSpace: "pre-line" }}>{props.description}</p>
          <Carousel>
            {props.images &&
              props.images.map((src, index) => {
                return (
                  <Carousel.Item key={"carousel_img_" + index}>
                    <img className="d-block w-100" src={src} alt={props.name} />
                  </Carousel.Item>
                );
              })}
          </Carousel>
        </div>
      </HyperModal>
    );
  };

  renderSizesOld = (props) => {
    const { t } = this.props;
    return (
      <div class="btn-group justified-content d-flex">
        {this.materials
          .find((material) => {
            return material.id === this.state.selectedMaterialId;
          })
          .sizes.map((size, index) => {
            return (
              <label class="u-check flex-grow-1" key={"size_" + index}>
                <input
                  class="g-hidden-xs-up g-pos-abs g-top-0 g-left-0"
                  type="radio"
                  value={size.id}
                  checked={this.state.selectedSizeId === size.id}
                  onChange={this.onSizeChanged}
                />
                <span class="btn btn-sm btn-block u-btn-outline-lightgray g-color-white--checked g-bg-primary--checked rounded-0">
                  {size.name} <br />
                  <span>
                    {size.price} {t("грн")}{" "}
                  </span>
                  <s class="g-color-gray-dark-v4 g-font-size-10">
                    {size.oldPrice}
                  </s>
                </span>
              </label>
            );
          })}
      </div>
    );
  };

  renderSizes = (props) => {
    const { t } = this.props;
    return (
      <div>
        {this.materials
          .find((material) => {
            return material.id === this.state.selectedMaterialId;
          })
          .sizes.map((size, index) => {
            return (
              <div class="form-group g-mb-10" key={"size_" + index}>
                <label class="u-check g-pl-25">
                  <input
                    class="g-hidden-xs-up g-pos-abs g-top-0 g-left-0"
                    name="radioSizes"
                    type="radio"
                    value={size.id}
                    checked={this.state.selectedSizeId === size.id}
                    onChange={this.onSizeChanged}
                  />
                  <div class="u-check-icon-font g-absolute-centered--y g-left-0">
                    <i class="fa" data-check-icon="" data-uncheck-icon=""></i>
                  </div>
                  {size.name}
                  {" - "}
                  <s class="g-color-gray-dark-v4 g-font-size-10">
                    {size.oldPrice} {t("грн")}
                  </s>{" "}
                  {size.price} {t("грн")}{" "}
                </label>
              </div>
            );
          })}
      </div>
    );
  };

  renderHangers = (props) => {
    const { t } = this.props;
    const hangers = props.hangers;
    if (!hangers || hangers.length <= 1) {
      return null;
    }
    return (
      <React.Fragment>
        <h3 class="h6 g-font-weight-400 g-mt-0 g-mt-20--md h5--md">
          {t("Кріплення")}
        </h3>
        <div class="btn-group justified-content d-flex">
          {hangers.map((hanger, index) => {
            return (
              <label class="u-check flex-grow-1" key={"hanger_" + index}>
                <input
                  class="g-hidden-xs-up g-pos-abs g-top-0 g-left-0 "
                  type="radio"
                  value={hanger.id}
                  checked={props.selectedHangerId === hanger.id}
                  onChange={props.onHangerChanged}
                />

                <span class="btn btn-sm btn-block u-btn-outline-lightgray g-color-white--checked g-bg-primary--checked rounded-0 h-100 d-inline-flex flex-column justify-content-center">
                  <span>
                    {hanger.name}

                    {hanger.id === "Лента" ? (
                      <>
                        <br />
                        <span>{t("безкоштовно")}</span>
                      </>
                    ) : hanger.price != 0 ? (
                      <>
                        <br />
                        <span>
                          +{hanger.price} {t("грн")}
                        </span>
                      </>
                    ) : (
                      <span>{"\u00A0"}</span>
                    )}
                  </span>
                </span>
                {hanger.info ? (
                  <a
                    class="u-badge-v1 g-bg-white g-brd-gray-light-v3 g-color-primary g-rounded-50x g-mt-5 g-mr-5 custom-badge"
                    onClick={(e) => props.onHangerInfoClick(e, hanger)}
                  >
                    ?
                  </a>
                ) : null}
              </label>
            );
          })}
        </div>
      </React.Fragment>
    );
  };

  render() {
    console.log("rendering: editor-materials");
    const { t } = this.props;
    let size = this.materials
      .find((material) => {
        return material.id === this.state.selectedMaterialId;
      })
      .sizes.find((size) => {
        return size.id === this.state.selectedSizeId;
      });
    let hangers = null;
    if (size) {
      hangers = size.hangers;
    }

    return (
      <React.Fragment>
        <h3 class="h5">Матеріал</h3>
        <div class="btn-group justified-content d-flex">
          {this.materials.map((material, index) => {
            return (
              <label class="u-check flex-grow-1" key={"material_" + index}>
                <input
                  class="g-hidden-xs-up g-pos-abs g-top-0 g-left-0"
                  type="radio"
                  value={material.id}
                  checked={this.state.selectedMaterialId === material.id}
                  onChange={this.onMaterialChanged}
                />
                <span class="btn btn-md btn-block u-btn-outline-lightgray g-color-white--checked g-bg-primary--checked rounded-0">
                  {material.name}
                </span>
                <a
                  class="u-badge-v1 g-bg-white g-brd-gray-light-v3 g-color-primary g-rounded-50x g-mt-5 g-mr-5 custom-badge"
                  onClick={(e) => this.onMaterialInfoClick(e, material)}
                >
                  ?
                </a>
              </label>
            );
          })}
        </div>
        <div class="g-pos-rel">
          <div class="">
            <h3 class="h6 g-font-weight-400 g-mt-0 g-mt-20--md h5--md">
              {t("Розмір")}
            </h3>
          </div>
          <div class="g-color-red g-pos-abs g-bottom-0 g-right-0">
            <span class="u-label g-rounded-3 g-font-size-10 g-bg-lightred g-py-3 g-pos-rel g-top-minus-1 g-ml-5">
              {t("Акційна ціна!")}
            </span>
          </div>
        </div>
        <this.renderSizes></this.renderSizes>
        <this.renderHangers
          hangers={hangers}
          selectedHangerId={this.state.selectedHangerId}
          onHangerChanged={this.onHangerChanged}
          onHangerInfoClick={this.onHangerInfoClick}
        ></this.renderHangers>

        <this.renderModalWindow
          isModalOpen={this.state.isModalOpen}
          onModalClose={this.onModalClose}
          name={this.state.modalName}
          description={this.state.modalDescription}
          images={this.state.modalImages}
        ></this.renderModalWindow>
      </React.Fragment>
    );
  }
}

export default withTranslation()(EditorMaterials);
